import {
  VIDEO_EXTENSIONS,
  PICTURE_EXTENSIONS,
  PDF_EXTENSIONS,
} from '@/helpers/constants'

export const prepareUpdatedChatMembers = (
  oldMembers = [],
  newMembers = [],
  uuid = '',
) => {
  const setActiveMembers = oldMembers.map(member => {
    const isActive = !!newMembers.find(
      newMember => member.uuid === newMember.uuid || member.uuid === uuid,
    )

    return {
      ...member,
      isActive,
    }
  })

  const onlyNewMembers = newMembers.filter(
    newMember => !oldMembers.find(member => member.uuid === newMember.uuid),
  )

  return [...setActiveMembers, ...onlyNewMembers]
}

export const getFileTypeByUrl = (fileUrl = '') => {
  let extension = ''
  if (typeof fileUrl === 'string') {
    extension = fileUrl
      .split(/[#?]/)[0]
      .split('.')
      .pop()
      .trim()
      .toLowerCase()
  }
  let type = null

  if (VIDEO_EXTENSIONS.includes(extension)) {
    type = 'video'
  } else if (PICTURE_EXTENSIONS.includes(extension)) {
    type = 'image'
  } else if (PDF_EXTENSIONS.includes(extension)) {
    type = 'pdf'
  }

  return { type, extension }
}

export const getFileTypeByName = (fileName = '') => {
  const extension = fileName
    .split('.')
    .pop()
    .trim()
    .toLowerCase()
  let type = null

  if (VIDEO_EXTENSIONS.includes(extension)) {
    type = 'video'
  } else if (PICTURE_EXTENSIONS.includes(extension)) {
    type = 'image'
  } else if (PDF_EXTENSIONS.includes(extension)) {
    type = 'pdf'
  }

  return { type, extension }
}

// @todo correct placeholder
export const filePlaceholder =
  'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAASiSURBVHgB7ZztThNBFIanuxVIUQpIiRXwI/KDxIT7vwp/mJhoAtFoE1CwpHxUoO3WfbesnZ1uJWy3+56W8yQETOh2Oc/smZlzxpba152+UWh4RqGiAsioADIqgIwKIKMCyKgAMiqAjAogowLIqAAyKoCMCiCjAsioADIqgIwKIKMCyKgAMiqAjAogowLIqAAyKoBM2cwo3cCYXq8U/ez7fVOe0aE0MwIQ8POrkjk596Lv+LcNBKws983a077ZrAZmVijNwtHEo6ZnGqfeSNDHsfjEmO2NYCZEiBZw0zHm4Mg35+2SycJKpW92671IiFTECkDwP30vR99tolQTBrYafiH3A8wFrVBS83JUFIL//lVXrASRApBqPn5NBh+Br68H5kX4NW7Cxe+ftDzz4zT5Cwj+/tuuyIlapIDDI8/8ag2j9dBRnPb01KqDdCQNcWMCqWSS4I97zUmrlHkumSbiBDSc9LG3lS1/4zXuiHdTkwRE3RFShj1KkTYqSyYzmKw3q8MMi2vfdGQ9BaIENC+St5PHOr7mXCNtpcRElIDzP8PglP3BCJ4UXMNe/Vxdq4CxdK2UXVnMb3FWWRpeq60CxmMvG/PcONnX6gqrTogS4Ft308sxUEmxsrY9ogQsLQx/zjNXd+Xtv/4hSoA9OjFq80gXuE77Zigzj4k9T0QJWH+aDA7K0JNi76pBVQWMx10yHp95Ez0FcXEuBpOxPgH3gGpnDHL3l4ZvsvLtp5eYgHc25DVoxAlAkOxlI8oHaMo8lIOwotq8TI7+msAOmchW9t5WL5GKUMn8cDjanEmjfY1StJ9IPQDVUYmI7YghgBjFLhjFa8/6Zikc0ct3u2UU2FrtwWvSSs679UDk6Aeie8LNi1LYnPEzT8R4it69DMLVldzmvOjTNP6EBTkcU5G283UR+QSgK4bGTF4dLMmnI0QJQKpB4P+3AcOIXqkMytW+d3cqIggbLbfGXDu7Xpf6WmC2a4Go5rwYAeOOoQCM4OfhLnlj9f7gDbpqaOqn94ClHVMRIWCwdCyPTLYIPPYFWecByGic+pEMGwR/b7uXa88hK3QBacGPG+p5lQ3is0KJc0Y+ngS+BKqAtLSDJnzWkxD3vdfnsKxhzxGQsP+Gm45o0xFGfFrwp5Wfo9z/OjniUWtKS31FQhPQcFJCHPxprlBwbVdCNE+c8JZFlHfGH20vNaNJcauYs5t4D0zA9lN2dObRTs1RBLjVTbcCOm0knZor/F2vbkZPvzEKZVhh2ass3BPjKShcwLGzy93Z4HXM3QbN78tHIMA+fogRyFwCuk/BacsrfEVUqAAU2ew/0D44y8I+CIBladEn5woV4ObYlQq/Tl9b5aYhmoDlRSOiIIZlqd0zuO3MsQD7hNrigpw2BMrbMVfznILs0bUgqFNV9of30pvnSdiegCU1RexDwUWfIy00DPG6G8GX9L/YcS/xfFRfL/a+Ci9H4wiJxA/XiD/8o+gm/kx8VsQ8I/pYymNABZBRAWRUABkVQEYFkFEBZFQAGRVARgWQUQFkVAAZFUBGBZBRAWRUABkVQEYFkFEBZFQAGRVARgWQUQFkVACZv6kI8O0OTllQAAAAAElFTkSuQmCC'

export const prepareTimetokenDate = token => Math.ceil(token / Math.pow(10, 4))

export const CHATS_LIST_TYPE = {
  ALL: 'ALL',
  FREE_CHATS: 'FREE_CHATS',
  NORMAL_CHATS: 'NORMAL_CHATS',
  SPRINT_CHATS: 'SPRINT_CHATS',
}
